<script setup lang="ts">
import { onBeforeMount } from 'vue';
import Social from './components/atoms/Social.vue';
import AppSnackbar from './components/layout/AppSnackbar.vue';
import Disconnect from './components/molecules/Disconnect.vue';

onBeforeMount(() => {
  const walletName = window.localStorage.getItem('walletName');
  if (walletName && walletName === `"Jupiter"`) {
    window.localStorage.setItem('walletName', `Jupiter`);
  }
});
</script>

<template>
  <v-app
    style="
      background-image: url('/bg.jpg');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    "
  >
    <header class="flex flex-row p-4">
      <img
        src="/logo.svg"
        alt="Jupiter Mobile Invite"
        width="104"
        height="36"
      />
      <Disconnect />
    </header>
    <v-main>
      <AppSnackbar></AppSnackbar>
      <router-view />
    </v-main>
    <footer class="flex flex-row items-center gap-x-2 p-4">
      <Social url="https://discord.com/invite/jup" name="discord" />
      <Social url="https://x.com/JupiterExchange" name="x" />
      <Social url="https://www.youtube.com/@Jupiter-Exchange" name="youtube" />
      <Social url="https://www.reddit.com/r/jupiterexchange/" name="reddit" />
    </footer>
  </v-app>
</template>
